
/* eslint-disable  */

import { Agent } from '@/graphql/codegen/generated/graphql';
import { defineComponent, PropType } from 'vue';
import { useStore } from 'vuex';
import selector from '../inputs/selector.vue';
import { SelectedAgent } from './AgentActionMenu.types';
import { notifyPresets } from './services/notifyPresets';

export default defineComponent({
  name: 'AssignmentPriority',
  setup() {
    const store = useStore();
    return { store };
  },
  mixins: [notifyPresets],
  components: {
    selector,
  },
  props: {
    selected: {} as any,
    agentName: {},
    bulk: { default: false },
    agentsList: {
      type: Array as PropType<SelectedAgent[]>,
    },
  },
  data() {
    return {
      range: ['HighAssignPriority', 'AboveNormalAssignPriority', 'NormalAssignPriority', 'BelowNormalAssignPriority', 'LowAssignPriority'],
    };
  },
  methods: {
    uniformOrNull(countA: number, countB: number) {
      const allA = countA === countB;
      const allB = countA === 0;
      return allA || allB ? allA : null;
    },
    async handleChange(e: any) {
      this.$emit('change', e.value);
    },
  },
  computed: {
    requestData() {
      return this.store.getters['main/dialogData'].data;
    },
    values() {
      if (this.bulk) {
        const selections: Agent['assignPriority'][] = [];
        this.agentsList?.forEach(agent => {
          if (selections.length <= 1 && !selections.includes(agent.assignPriority)) selections.push(agent.assignPriority);
        });

        return { agentName: this.agentName, action: 'SetAgentAssignPriority', min: 'High', max: 'Low', selected: null, range: this.range };
      }
      return { agentName: this.agentName, action: 'SetAgentAssignPriority', min: 'High', max: 'Low', selected: !isNaN(this.selected) ? this.range[this.selected] : this.selected, range: this.range };
    },
  },
});
